<p-card *ngIf="this.hasSubscriptions" class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title>Subscription Information</ng-template>

  <ul class="p-0 m-0 list-none border-top-1 surface-border">
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold md:w-2/12 text-primary-300">
        Current Plan
      </div>
      <div class="w-8/12 md:w-10/12 md:flex-order-0 flex-order-1 text-400">
        {{ (customer_overview()?.subscriptions)!.data[0]!.plan?.name! }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">Price</div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{
          (customer_overview()?.subscriptions)!.data[0]!.actual_amount
            | currency : "USD"
        }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Next Due
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ (customer_overview()?.subscriptions)!.data[0]!.next_due | date }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Download / Upload
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{
          (customer_overview()?.subscriptions)!.data[0]!.plan?.download_speed
        }}
        /
        {{ (customer_overview()?.subscriptions)!.data[0]!.plan?.upload_speed }}
      </div>
    </li>
  </ul>
  <ng-template #footer>
    <div class="w-full p-4 mt-4 font-semibold text-primary-300">
<!--       <p-button
        label="Change Plan"
        pRipple
        icon="pi pi-wallet"
        class="p-4 rounded-md text-secondary bg-primary-500"
        (onClick)="changePlan()" /> -->
    </div>
  </ng-template>
</p-card>
